<template>
  <l-layout :layout="['xs12']" bottom-space>
    <l-data-table
      :filter-items="filterItems"
      :get-data-func="getUsers"
      :headers="userHeaders"
      @click:row="goDetails('readonly',$event.item)"
      clickable
      ref="userList"
      hide-title-search
      title-text="访客用户列表">
    </l-data-table>
  </l-layout>
</template>

<script>
  import {time} from '../../../ladmin/utils/time'

  export default {
    name: 'registerUser',
    data: () => ({
      filterItems: [
        {
          prependIcon: '$vuetify.icons.person',
          key: 'visitorName',
          value: '',
          label: '访客姓名',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
        {
          prependIcon: '$vuetify.icons.phone',
          key: 'visitorPhone',
          value: '',
          label: '电话号码',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
        {
          prependIcon: '$vuetify.icons.idCardType',
          key: 'visitorIdNum',
          value: '',
          label: '身份证件',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
        {
          prependIcon: '$vuetify.icons.group',
          key: 'visitorOrg',
          value: '',
          label: '单位|车牌',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
      ],
      userHeaders: [
        {text: '用户姓名', value: 'visitorName', align: 'left', placeholder: 'N/A'},
        {text: '电话号码', value: 'visitorPhone', align: 'right', placeholder: 'N/A'},
        {text: '身份证件', value: 'visitorIdNum', align: 'right', placeholder: 'N/A'},
        {text: '单位|车牌', value: 'visitorOrg', align: 'right', placeholder: 'N/A'},
        {text: '登记时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
        {text: '', value: '', align: 'right', width: '80px', sortable: false}
      ],
    }),
    methods: {
      async getUsers ({pagination, sortStack, filterItems, search}) {
        return this.$store.dispatch('userAdmin/getVisitorUsers', {
          pagination,
          sortStack,
          filter: filterItems,
          search: {key: 'name', value: search}
        })
      },
      goDetails (status, item) {
        let selectionString = document.getSelection().toString()
        if (!selectionString) {
          this.$router.push({
            name: 'PersonStatisticDetails',
            params: {plate: item.visitorPhone},
            query: {id: item.id,plate: item.visitorPhone}
          })
        }
      },

    },
  }
</script>

<style scoped>

</style>
